<template>
  <v-container grid-list-xl class="pa-5">
    <v-row class="mb-5">
      <v-col cols="12" sm="6" md="4" lg="4" xl="4">
        <BlockCard
          title="Total Kuota"
          :value="`${this.$options.filters.toTS(stat && stat.total_kuota)}`"
          icon="mdi-ballot-recount"
          color="#FFB74D"
          icon-color="primary"
          icon-avatar-color="primary lighten-4"
          class="elevation-custom"
        />
      </v-col>

      <v-col cols="12" sm="6" md="4" lg="4" xl="4">
        <BlockCard
          title="Pengguna"
          :value="`${this.$options.filters.toTS(stat.total_kuota_organisasi)}`"
          icon="mdi-account"
          color="#FFB74D"
          icon-color="red"
          icon-avatar-color="red lighten-4"
          class="elevation-custom"
        />
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="4" xl="4">
        <BlockCard
          title="Sisa Kuota"
          :value="`${this.$options.filters.toTS(stat.sisa_kuota)}`"
          icon="mdi-ballot-recount"
          color="#FFB74D"
          icon-color="primary"
          icon-avatar-color="primary lighten-4"
          class="elevation-custom"
        />
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="4" xl="4">
        <BlockCard
          title="Sudah Verifikasi Wajah"
          :value="`${this.$options.filters.toTS(stat.user_enrolled)}`"
          icon="mdi-account-check"
          class="elevation-custom"
          color="#F48C6C"
        />
      </v-col>

      <v-col cols="12" sm="6" md="4" lg="4" xl="4">
        <BlockCard
          class="elevation-custom"
          icon-color="blue lighten-1"
          icon-avatar-color="blue lighten-5"
          title="Total Organisasi"
          :value="stat.total_organisasi"
          icon="mdi-office-building"
          color="#FBC02D"
        />
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="4" xl="4">
        <BlockCard
          title="Total Aktivasi"
          :value="`${this.$options.filters.toTS(stat.total_aktivasi)}`"
          icon="mdi-account-star"
          icon-color="amber lighten-1"
          icon-avatar-color="amber lighten-4"
          class="elevation-custom"
          color="#4DB6AC"
        />
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="4" xl="4">
        <BlockCard
          title="Total Grup dalam Tenant"
          :value="stat.total_group"
          icon="mdi-home-group"
          icon-color="purple"
          icon-avatar-color="purple lighten-4"
          color="white"
          class="elevation-custom"
          @pilih="onCheckGroup"
        />
      </v-col>
    </v-row>
    <v-card v-if="isStatisikGrup" class="my-2">
      <v-card-text>
        <v-row>
          <v-col>
            <span class="subheader font-weight-bold primary--text"
              >Jumlah TNP saat ini</span
            >
            {{ (groups && groups[1] && groups[1]["jumlah"]) || 0 }} / 800
          </v-col>
          <v-col>
            <span class="subheader font-weight-bold primary--text"
              >Jumlah PNS saat ini</span
            >
            {{ (groups && groups[0] && groups[0]["jumlah"]) || 0 }} / 2272
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <Aktivasi />
    <PopupDaftarGrup ref="popupgrup" />
  </v-container>
</template>

<script>
import BlockCard from "@/components/BlockCard";
import MChartLine from "@/components/MChartLine";
import MChartPie from "@/components/MChartPie";
import Aktivasi from "@/modules/organisasi/pages/Aktivasi.vue";

export default {
  components: {
    BlockCard,
    MChartLine,
    MChartPie,
    Aktivasi,
    PopupDaftarGrup: () => import("../components/Grup")
  },
  data() {
    return {
      stat: {},
      groups: {}
    };
  },
  mounted() {
    this.loadStatistik();
  },
  computed: {
    sisaKuota() {
      const stat = {
        total_kuota: +this.stat.total_kuota || 0,
        pengguna: +this.stat.pengguna || 0,
        total_organisasi: +this.stat.total_organisasi || 0,
        total_aktivasi: +this.stat.total_aktivasi || 0,
        user_enrolled: +this.stat.user_enrolled || 0
      };

      const result = stat.total_kuota - stat.pengguna;

      return Math.floor(result) || 0;
    },

    isStatisikGrup() {
      return ["TEN-PY6EL", "TEN-M5IJF"].includes(this.current_user.kode_tenant);
    }
  },
  methods: {
    loadStatistik() {
      this.$store
        .dispatch("tenant/statistik", {
          id_tenant: this.current_user.kode_tenant
        })
        .then(res => {
          this.stat = res.data;
        })
        .then(() => {
          if (this.isStatisikGrup) {
            this.$store
              .dispatch("grup/get", {
                organisasi_id: this.tenant_id,
                params: { is_jumlah: 1 }
              })
              .then(({ data }) => {
                this.groups = (data && data.data) || (data) || {};
              });
          }
        });
    },
    onCheckGroup() {
      // if (!this.isCan('group.index')) return
      if (!this.isCan("organisasi.index")) return;
      this.$store
        .dispatch("organisasi/get", { count: 100 })
        .then(({ data }) => {
          const orgs = (data && data.data) || [];
          this.$refs.popupgrup.open();

          this.$nextTick(() => {
            this.$refs.popupgrup.organisasi = orgs;
          });
        });
    }
  }
};
</script>

<style scoped>
.elevation-custom {
  -webkit-box-shadow: 0px 0px 20px 3px #4362be56 !important;
}
</style>
